import cookie from '@s-ui/js/lib/cookie'

import factoryLogger from '../../logger/index.js'
import SmartbannerValueObjectsFactory from '../ValueObjects/factory.js'
import CookieSmartbannerRepository from './CookieSmartbannerRepository.js'
import EmptyCookieSmartbannerRepository from './EmptyCookieSmartbannerRepository.js'

export default class SmartbannerRepositoriesFactory {
  static CookieSmartbannerRepository = ({config}) =>
    new CookieSmartbannerRepository({
      config,
      jsCookie: cookie,
      smartbannerValueObjectFactory: SmartbannerValueObjectsFactory.smartbannerValueObject,
      log: factoryLogger({prefix: 'CookieSmartbannerRepository'})
    })

  static emptyCookieSmartbannerRepository = () => new EmptyCookieSmartbannerRepository()
}
